export default __webpack_public_path__ + "6a8c49c3edc6842a5abe8576a263670a.png";